import { FSAccessorySub, mapFSAccessorySubs } from "./AccessorySub";

/* **************************************************** Finishing Shedule Accessory Name */
export interface FSAccessory {
    id: number;
    category?: 'Light' | 'Door' | 'Paint' | 'Bathroom' | 'Kitchen' | 'Tiles' | 'Floor Finishing' | 'Others';
    accessory_name: string;
    created_by: number | null;
    sub_accessory?: FSAccessorySub[];
}

export const mapFSAccessory = (data: any): FSAccessory => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAccessory = {
        id: data.id,
        category: data.category,
        accessory_name: data.accessory_name,
        created_by: data.created_by || null,
        sub_accessory: (data.sub_accessory && Array.isArray(data.sub_accessory)) ? mapFSAccessorySubs(data.sub_accessory) : [],
    };

    return res;
};

export const mapFSAccessories = (data: any[]): FSAccessory[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAccessory);
};
